<div class="sidebar">
  <div class="order-test">
    <div>
      <h4 class="order-test-title">Medical Consultation</h4>
      <p>Ask the doctor.</p>
      
      <div class="add-consultation-container">
        <a 
          *ngIf="(isLoggedIn | async)"
          (click)="addConsultationToCart()"
          class="sigma_btn btn-sm">
          {{ isChecked ? 'Remove' : 'Book Now' }}
        </a>
        <a 
          *ngIf="!(isLoggedIn | async)" 
          routerLink="/authenticate/login" 
          class="sigma_btn btn-block btn-sm">
          Book Now
        </a>
        <a *ngIf="isChecked" class="sigma_btn btn-sm cart" (click)="goToCart()">
          View Cart
        </a>
      </div>
    </div>
  </div>
</div>